<template>
    <div>
        <div class="screen"
             v-if="state === 'intro'">
            <h1>
                <el-finger>👉</el-finger>
                StemWijzerWijzer
                <el-finger>👈</el-finger>
            </h1>

            <p class="lead">
                Er zijn meer stemwijzers bij de komende verkiezingen dan partijen om op te stemmen. Wat een dilemma! Gelukkig biedt de StemWijzerWijzer uitkomst.
            </p>

            <button class="btn btn--large" v-on:click="start">
                Start
            </button>

            <p>Door <a href="https://www.haykranen.nl/">Hay Kranen</a></p>

            <p class="small">
                Disclaimer: net zoals sommige van de stemwijzers in deze test moet u deze test zelf
                misschien ook niet al te serieus nemen.
            </p>
        </div>

        <div class="screen"
             v-if="state === 'question'">
            <p class="indicator">Vraag {{index + 1}} van {{questions.length}}</p>

            <h2 class="question">{{question.question}}</h2>

            <button class="btn" v-on:click="answer(1)">
                {{question.answer1}}
            </button>

            <button class="btn" v-on:click="answer(2)">
                {{question.answer2}}
            </button>
        </div>

        <div class="screen"
             v-if="state === 'calc'">
            <el-finger v-on:click="state = 'results'">👉</el-finger>
            <h2>Uw resultaten worden berekend...</h2>

            <p class="small">
                Nee, niet echt natuurlijk. Maar deze animatie geeft u de illusie
                dat er allemaal spannende dingen gebeuren.
            </p>
        </div>

        <div class="screen"
             v-if="state === 'readmind'">
            <el-finger>🧠</el-finger>
            <h2>Ik lees nu uw gedachten...</h2>

            <p class="small">
                Over enkele seconden krijgt u een stemadvies dat geheel bij u past.
            </p>
        </div>

        <div class="screen"
             v-if="state === 'results'">
            <h1>
                <el-finger>👉</el-finger>
                StemWijzerWijzer
                <el-finger>👈</el-finger>
            </h1>

            <p v-if="topResults.length === 1">
                Gefeliciteerd! Er is één stemwijzer die helemaal bij u past!
                Nu nog deze stemwijzer doen en u de partij die daar uitkomt is gegarandeerd uw politieke zielsverwant.
            </p>

            <p v-if="topResults.length !== 1">
                Er zijn {{topResults.length}} stemwijzers die hetzelfde aantal punten kregen.
                Onze StemWijzerWijzerWijzer is nog in ontwikkeling, dus u moet hier zelf even kiezen welke het beste
                bij u past. Veel succes!
            </p>

            <ul class="results">
                <li v-for="result in results"
                    v-bind:key="result.id">
                    <a v-bind:href="result.url"
                       target="_blank">
                        <img v-bind:src="result.img"
                             v-bind:alt="'Logo van ' + result.title" />
                    </a>

                    <a v-bind:href="result.url"
                       target="_blank">
                       {{result.title}}
                    </a>

                    <span class="small">{{result.points}} punten</span>
                </li>
            </ul>

            <menu class="screen__buttons">
                <button
                    v-if="!showAllResults"
                    class="btn--link"
                    v-on:click="showAllResults = true">
                    Toon alle stemwijzers
                </button>

                <button
                    class="btn--link"
                    v-on:click="reset">
                    Nog een keer?
                </button>

                <button
                    class="btn--link"
                    v-on:click="readMind">
                    Ideale partij met gedachtenlezen
                </button>
            </menu>

            <p>
                <a href="https://www.haykranen.nl/circulaire/?ref=stemwijzerwijzer">
                    <img src="./../img/circulaire.svg"
                         class="circulaire"
                         alt="Het logo van 'De Circulaire'" />
                </a>

                Vond u dit leuk? Abonneer u dan op <a href="https://www.haykranen.nl/circulaire/">De Circulaire</a>. Dat is mijn
                tweewekelijkse nieuwsbrief voor slimme mensen die van kattengifjes houden, en natuurlijk ook van stemwijzerwijzers.
            </p>

            <p>
                Of doe een kleine donatie <a href="https://tikkie.me/pay/hpdnnrs9fc6kqiul9qdd" target="blank">via Tikkie</a>.
            </p>
        </div>
    </div>
</template>

<script>
    import { timeout } from 'donot';
    import { getData } from '../data.js';
    import ElFinger from './el-finger.vue';

    export default {
        components : { ElFinger },

        computed : {
            allResults() {
                return Object.values(this.sites).sort((a, b) => {
                    return a.points < b.points ? 1 : -1;
                });
            },

            maxPoints() {
                return this.allResults[0].points;
            },

            question() {
                if (this.questions.length) {
                    return this.questions[this.index];
                } else {
                    return {};
                }
            },

            results() {
                return this.showAllResults ? this.allResults : this.topResults;
            },

            topResults() {
                return this.allResults.filter(r => r.points === this.maxPoints);
            }
        },

        data() {
            return {
                index : 0,
                questions : [],
                showAllResults : false,
                sites : {},
                state : !!(window.location.hash) ? window.location.hash.slice(1) : 'intro'
            };
        },

        methods : {
            answer(type) {
                for (const siteId in this.sites) {
                    const site = this.sites[siteId];

                    if (this.question.sites.includes(siteId) && type === 1) {
                        site.points += 1;
                    }

                    if (!this.question.sites.includes(siteId) && type === 2) {
                        site.points += 1;
                    }
                }

                this.next();
            },

            async next() {
                if (this.index < (this.questions.length - 1)) {
                    this.index += 1;
                } else {
                    this.state = 'calc';
                    await timeout(4000);
                    this.state = 'results';
                }
            },

            async readMind() {
                this.state = 'readmind';
                await timeout(5000);
                window.location = 'https://www.youtube.com/watch?v=dQw4w9WgXcQ';
            },

            reset() {
                window.location.reload();
            },

            start() {
                this.state = 'question';
            }
        },

        async mounted() {
            const data = await getData();
            this.questions = data.questions;
            this.sites = data.sites;
        }
    }
</script>